import { TimetableDepartureResponse } from '../../api/TimetableDepartureResponse';


export class TimetableDeparture {
    routeCode: string;
    routeName: string;
    departureDateTime: Date;
    arrivalDateTime: Date;
    journeyLength: string;
    vessel: string;
    
    constructor(resp : TimetableDepartureResponse) {
    	
    	this.routeCode = resp.routeCode;
    	this.routeName = resp.routeName;
    	this.departureDateTime = new Date(resp.departureDateTime);
    	this.arrivalDateTime = new Date(resp.arrivalDateTime);
    	this.vessel = resp.vessel;
    	this.journeyLength = resp.journeyLength;
    }
    
}
